import ErrorWrapper from './error-wrapper';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

export default function IpRestrictedPage() {
  return (
    <ErrorWrapper>
      <Card variant="outlined" sx={{ maxWidth: 920, zIndex: 2, px: 4, py: 6 }}>
        <CardHeader
          title={'IP Restricted'}
          subheader="Your domain has IP Restriction enabled for gPanel. Your IP address falls outside of the allowed range. Please contact your domain administrator for access."
        />
      </Card>
    </ErrorWrapper>
  );
}
